var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13C8.45055 13 8.40222 13.0147 8.36111 13.0421C8.32 13.0696 8.28795 13.1086 8.26903 13.1543C8.25011 13.2 8.24516 13.2503 8.2548 13.2988C8.26445 13.3473 8.28826 13.3918 8.32322 13.4268C8.35819 13.4617 8.40273 13.4855 8.45123 13.4952C8.49972 13.5048 8.54999 13.4999 8.59567 13.481C8.64135 13.462 8.6804 13.43 8.70787 13.3889C8.73534 13.3478 8.75 13.2994 8.75 13.25C8.75 13.1837 8.72366 13.1201 8.67678 13.0732C8.62989 13.0263 8.5663 13 8.5 13Z",
    stroke: "#242526",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11V6",
    stroke: "#242526",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58067 1.67317C9.48146 1.47118 9.32761 1.30105 9.1366 1.18206C8.94559 1.06307 8.72505 1 8.50001 1C8.27496 1 8.05443 1.06307 7.86341 1.18206C7.6724 1.30105 7.51856 1.47118 7.41934 1.67317L1.10401 14.5385C1.02799 14.6932 0.992631 14.8646 1.00128 15.0367C1.00992 15.2088 1.06229 15.3759 1.15342 15.5221C1.24456 15.6684 1.37147 15.789 1.52216 15.8726C1.67285 15.9562 1.84235 16 2.01467 15.9998H14.9853C15.1577 16 15.3272 15.9562 15.4779 15.8726C15.6285 15.789 15.7555 15.6684 15.8466 15.5221C15.9377 15.3759 15.9901 15.2088 15.9987 15.0367C16.0074 14.8646 15.972 14.6932 15.896 14.5385L9.58067 1.67317Z",
    stroke: "#242526",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTask);
export default __webpack_public_path__ + "static/media/myTask.953fa009dd208014d69ae19586b3283c.svg";
export { ForwardRef as ReactComponent };